import React, { useEffect, useState } from "react";
import Select, { ActionMeta } from "react-select";
import { useNavigate } from "react-router-dom";
import { getLocalStorage } from "../Util/LocalStorage";

interface Action {
  name: string;
  url?: string;
  modal?: any;
  keywords: string[];
}

function SearchField({
  handleCloseSearchModal,
  setModalStatus,
}: {
  handleCloseSearchModal: () => void;
  setModalStatus: any;
}) {
  const Permissions = (getLocalStorage("permissions") as string[] | null) || [];
  const actions: Action[] = [
    {
      name: "Add Product",
      url: "/products/add",
      keywords: ["add products", "create products"],
      isVisible: Permissions.includes("add-product"),
    },
    {
      name: "Add Category",
      url: "/categories/add",
      keywords: ["add categories", "create categories"],
      isVisible: Permissions.includes("add-category"),
    },
    {
      name: "Add Role",
      url: "/roles/add",
      keywords: ["add store", "create store"],
      isVisible: Permissions.includes("add-role"),
    },
    {
      name: "Add Currency",
      url: "/currencies/add",
      keywords: ["add Currency", "create Currency"],
      isVisible: Permissions.includes("add-currency"),
    },
    {
      name: "Add User Group",
      url: "/users-group/add",
      keywords: ["add User Group", "create User Group"],
      isVisible: Permissions.includes("add-user-group"),
    },
    {
      name: "Add Ingredients",
      url: "/ingredients/add",
      keywords: ["add Ingredients", "create Ingredients"],
      isVisible: Permissions.includes("add-ingredient"),
    },
    {
      name: "Add Attribute",
      url: "/attributes/add",
      keywords: ["add attributes", "create attributes"],
      isVisible: Permissions.includes("add-attribute"),
    },
    {
      name: "Add Tax Type",
      url: "/tax-types/add",
      keywords: ["add taxTypes", "create taxTypes"],
      isVisible: Permissions.includes("add-tax-type"),
    },
    {
      name: "Add User Type",
      url: "/user-types/add",
      keywords: ["add userTypes", "create userTypes"],
      isVisible: Permissions.includes("add-user-type"),
    },
    {
      name: "Add Payment Terms",
      url: "/payment-terms/add",
      keywords: ["add paymentTerms", "create paymentTerms"],
      isVisible: Permissions.includes("add-payment-terms"),
    },
    {
      name: "Add Bank Details",
      url: "/bank-details/add",
      keywords: ["add bankDetails", "create bankDetails"],
      isVisible: Permissions.includes("add-bank-detail"),
    },
    {
      name: "Add Store",
      url: "/stores/add",
      keywords: ["add stores", "create stores"],
      isVisible: Permissions.includes("add-store"),
    },
    {
      name: "Add Logistic Detail",
      url: "/logistic-details/add",
      keywords: ["add logisticDetails", "create logisticDetails"],
      isVisible: Permissions.includes("add-logistic-detail"),
    },
    {
      name: "Add Terms & Condition",
      url: "/terms-and-conditions/add",
      keywords: ["add termsAndConditions", "create termsAndConditions"],
      isVisible: Permissions.includes("add-terms-and-condition"),
    },
    {
      name: "Add User",
      url: "/users/add",
      keywords: ["add users", "create users"],
      isVisible: Permissions.includes("add-user"),
    },
    {
      name: "Add Unit Of Measurement",
      url: "/unit-of-measurements/add",
      keywords: ["add unitOfMeasurements", "create unitOfMeasurements"],
      isVisible: Permissions.includes("add-unit-of-measurement"),
    },
    {
      name: "Add Tax",
      url: "/taxs/add",
      keywords: ["add taxs", "create taxs"],
      isVisible: Permissions.includes("add-tax"),
    },
    {
      name: "Add Buyer & Supplier",
      modal: { buyersAndSupplierStatus: true },
      keywords: ["add Buyer & Supplier", "create Buyer & Supplier"],
      isVisible: Permissions.includes("add-counter-party-tag"),
    },
  ].filter((action) => action.isVisible !== false);

  const navigate = useNavigate();
  const [selectedOption, setSelectedOption] = useState<{
    label: string;
    value: Action;
  } | null>(null);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [options, setOptions] = useState<Action[]>([]);

  useEffect(() => {
    const searchActions = (input: string): Action[] => {
      return actions.filter(
        (action) =>
          action.keywords.some((keyword) =>
            keyword.toLowerCase().includes(input),
          ) || action.name.toLowerCase().includes(input),
      );
    };
    setOptions(searchActions(searchTerm));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm]);

  const handleInputChange = (inputValue: string) => {
    setSearchTerm(inputValue);
  };

  const handleOptionChange = (
    newValue: { label: string; value: Action } | null,
    actionMeta: ActionMeta<{ label: string; value: Action }>,
  ) => {
    setSelectedOption(newValue);
    if (newValue?.value?.url) {
      navigate(newValue.value.url);
      handleCloseSearchModal();
    } else if (newValue?.value?.modal) {
      setModalStatus((prevState: any) => ({
        ...prevState,
        ...newValue?.value?.modal,
      }));
      handleCloseSearchModal();
    }
  };

  return (
    <div className="d-flex align-items-center">
      <div style={{ width: "100%", marginRight: "10px" }}>
        <Select
          options={options.map((option) => ({
            label: option.name as string,
            value: option,
          }))}
          isSearchable
          placeholder="Search...."
          onChange={handleOptionChange}
          onInputChange={handleInputChange}
          value={selectedOption}
        />
      </div>
    </div>
  );
}

export default SearchField;
